export const LIST_LOCALIZATIONS_REQUEST = 'list_localizations_request'
export const LIST_LOCALIZATIONS_RESPONSE = 'list_localizations_response'

export const LOCALIZATIONS_ERROR = 'localizations_error'
